import axios from 'axios';
import { setupAuthInterceptors } from './authInterceptor';
import { extractErrorMessage } from '../utils/errorHandler';

const API_URL = process.env.REACT_APP_API_URL || 'https://accurix-backend-zq4b.onrender.com/api/v1';

// Create axios instance
const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Setup auth interceptors (includes token refresh on 401)
setupAuthInterceptors(apiClient, 'Transactions');

export const getTransactions = async (companyId = null, filters = {}) => {
  try {
    // Build query parameters
    const params = { ...filters };
    if (companyId) {
      params.company_id = companyId;
    }

    // Get transactions with optional filtering
    const response = await apiClient.get('/transactions/', { params });
    return response.data;
  } catch (error) {
    throw new Error(extractErrorMessage(error));
  }
};

export const getTransactionById = async (id) => {
  try {
    const response = await apiClient.get(`/transactions/${id}/`);
    return response.data;
  } catch (error) {
    throw new Error(extractErrorMessage(error));
  }
};

export const createTransaction = async (data) => {
  try {
    const response = await apiClient.post('/transactions/', data);
    return response.data;
  } catch (error) {
    throw new Error(extractErrorMessage(error));
  }
};

export const updateTransaction = async (id, data) => {
  try {
    const response = await apiClient.patch(`/transactions/${id}/`, data);
    return response.data;
  } catch (error) {
    throw new Error(extractErrorMessage(error));
  }
};

export const deleteTransaction = async (id) => {
  try {
    const response = await apiClient.delete(`/transactions/${id}/`);
    return response.data;
  } catch (error) {
    throw new Error(extractErrorMessage(error));
  }
};
